import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell, TabbedPage, type TabbedPageTab } from "../../components/layout";
import WidgetsPage from "./ui/WidgetsPage";
import QueryListPage from "../dashboard-queries/ui/QueryListPage";

/** Widgets and dashboard queries are two halves of the same "define data + how it is shown" work. */
const Widgets = () => {
  const { t } = useTranslation();
  const tabs = useMemo<TabbedPageTab[]>(
    () => [
      {
        key: "widgets",
        label: t("nav.widgets"),
        icon: <WidgetsOutlinedIcon fontSize="small" />,
        render: () => <WidgetsPage />,
      },
      {
        key: "queries",
        label: t("nav.dashboardQueries"),
        icon: <ManageSearchOutlinedIcon fontSize="small" />,
        render: () => <QueryListPage />,
      },
    ],
    [t]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <TabbedPage title={t("hub.widgetsQueries.title")} tabs={tabs} />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default Widgets;
